import { render, staticRenderFns } from "./TeamInvite.vue?vue&type=template&id=3afa1dd9&scoped=true&"
import script from "./TeamInvite.vue?vue&type=script&lang=js&"
export * from "./TeamInvite.vue?vue&type=script&lang=js&"
import style0 from "./TeamInvite.vue?vue&type=style&index=0&id=3afa1dd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa1dd9",
  null
  
)

export default component.exports